export default [
  {
    key: 'email',
    label: 'field.email',
    placeholder: 'placeholder.email',
    rules: 'required|email|max:100',
    type: 'text',
    cols: 12,
  },
]
